// extracted by css-extract-rspack-plugin
export default {"Well":"QuestionDisplayToggle-module__Well___xrQav","ToggleIcon":"QuestionDisplayToggle-module__ToggleIcon___hLIrA","active":"QuestionDisplayToggle-module__active___vGorH"};